import { Link } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react';

import { useShop } from '@/hooks/useShop';
import { useShopPath } from '@/hooks/useShopPath';
import { useBillingStatus } from '@/hooks/useBillingStatus';

/**
 * Full-bleed red banner shown above everything when the trial has expired.
 * Non-dismissible by design — the dashboard below renders at 60% opacity and
 * is non-interactive (see `AppLayout`) so the only allowed action is to
 * reactivate via Settings.
 *
 * Mirrors fresh-dashboard's `ExpiredTopBanner.tsx`.
 */
export function ExpiredTopBanner() {
	const { shopPath } = useShopPath();
	const { shop } = useShop();
	const { billing } = useBillingStatus(shop?.id);
	const to = shopPath('/settings/store/billing');
	// Customer-cancelled paying sub → don't call it a lapsed trial.
	const cancelled = billing?.cancellationReason === 'cancellation_requested';
	return (
		<div className="w-full bg-destructive text-destructive-foreground">
			<div className="flex w-full items-center gap-3 px-6 py-3 md:px-10">
				<AlertTriangle className="h-5 w-5 shrink-0" />
				<span className="text-sm font-medium">
					{cancelled
						? 'Your Unify subscription has ended. Restart it to get your storefront, ads and orders back online.'
						: 'Your free trial has ended. Reactivate to keep your storefront, ads and orders running.'}
				</span>
				<Link
					to={to}
					className="ml-auto inline-flex items-center rounded-full border border-destructive-foreground/70 px-4 py-1.5 text-sm font-semibold text-destructive-foreground transition hover:bg-destructive-foreground/10"
				>
					Reactivate now
				</Link>
			</div>
		</div>
	);
}
